import React, { FC } from 'react';
import styled from 'styled-components';
import { ZTooltip } from '../../../../../../widgets/ztooltip';
import WarningIcon from 'src/shared/material_icons/alert/warning.svg';
import { T } from 'src/shared/helpers';

const WarningTrigger = styled.span`
    display: inline-flex;
    width: 24px;
    height: 24px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    color: #a85a08;
    border-radius: 5px;

    svg {
        width: 16px;
        height: 16px;
        fill: currentColor;
    }
`;

const WarningList = styled.div`
    display: grid;
    gap: 3px;
    max-width: 270px;
    color: var(--composer-fg, #1e2a38);
    font-size: 11px;
    line-height: 14px;

    strong {
        color: #874b0b;
        font-size: 10px;
        letter-spacing: 0.02em;
        text-transform: uppercase;
    }

    ul {
        display: grid;
        gap: 2px;
        margin: 0;
        padding-left: 15px;
    }
`;

interface ComposerValidationTooltipProps {
    messages: string[];
    ariaLabel?: string;
}

const ComposerValidationTooltip: FC<ComposerValidationTooltipProps> = ({ messages, ariaLabel }) => {
    const uniqueMessages = Array.from(new Set(messages.filter(Boolean)));
    if (uniqueMessages.length === 0) return null;

    const label = ariaLabel || uniqueMessages.join('. ');
    return (
        <ZTooltip
            compact
            maxWidth={290}
            html={
                <WarningList>
                    <strong>{uniqueMessages.length === 1 ? T._('Warning', 'Admin') : T._('Warnings', 'Admin')}</strong>
                    <ul>
                        {uniqueMessages.map((message) => (
                            <li key={message}>{message}</li>
                        ))}
                    </ul>
                </WarningList>
            }
        >
            <WarningTrigger role='img' aria-label={label} tabIndex={0}>
                <WarningIcon />
            </WarningTrigger>
        </ZTooltip>
    );
};

export default ComposerValidationTooltip;
